export const showNotification = (message, type = 'info') => {
  const existingNotification = document.querySelector('.notification');
  if (existingNotification) {
    existingNotification.remove();
  }
  
  const notification = document.createElement('div');
  notification.className = `notification fixed top-20 right-5 z-[60] transform translate-x-full transition-transform duration-300 max-w-sm`;
  
  const bgColor = type === 'success' ? 'bg-green-500' : 
                 type === 'error' ? 'bg-red-500' : 
                 type === 'warning' ? 'bg-yellow-500' : 'bg-primary';
  
  const getNotificationIcon = (type) => {
    switch (type) {
      case 'success': return 'fa-check-circle';
      case 'error': return 'fa-exclamation-circle';
      case 'warning': return 'fa-exclamation-triangle';
      default: return 'fa-info-circle';
    }
  };
  
  notification.innerHTML = `
    <div class="${bgColor} text-white p-4 rounded-xl shadow-lg">
      <div class="flex items-center gap-3">
        <i class="fas ${getNotificationIcon(type)}"></i>
        <span>${message}</span>
      </div>
    </div>
  `;
  
  document.body.appendChild(notification);
  
  setTimeout(() => {
    notification.classList.remove('translate-x-full');
    notification.classList.add('translate-x-0');
  }, 100);
  
  setTimeout(() => {
    notification.classList.add('translate-x-full');
    notification.classList.remove('translate-x-0');
    setTimeout(() => {
      if (notification.parentNode) {
        notification.remove();
      }
    }, 300);
  }, 1500);
}; 